import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { getUpgradeUrl } from '../../helpers/upgradeUrl';
import { MessageIcon } from './icons';

/*
    Message types

    info -  alert-info
    danger - alert-danger
    success - alert-success
    warning - alert-warning


*/

class MessageCustom extends Component {
    constructor() {
        super();
    }

    // Send legacy + active users to the AI trial upgrade flow when this message links to an
    // upgrade / reactivate CTA (change_plan). Cancellation links and unrelated links are untouched.
    getLink() {
        const { link } = this.props;
        if (link?.includes('/customers/change_plan') && !link.includes('cancellation')) {
            return getUpgradeUrl(link);
        }
        return link;
    }

    render() {
        const { t } = this.props;
        const messageType = this.props.message_type ?? 'alert-danger';
        const header =
            this.props.header && t(`${this.props.header}`, { defaultValue: this.props.header });
        const message =
            typeof this.props.message === 'string'
                ? t(`${this.props.message}`, { defaultValue: this.props.message })
                : this.props.message;

        return (
            <div
                className={`custom-message alert ${messageType} alert-dismissible fade show  mb-8`}
                role="alert"
            >
                <div className="custom-message-body">
                    <MessageIcon type={messageType} />
                    <div>
                        {header &&
                            (this.props.isHeaderSeperated ? (
                                <div className="custom-message-title">{header}</div>
                            ) : (
                                <>
                                    <span className="custom-message-title">{header}</span>
                                    {' — '}
                                </>
                            ))}
                        {message}
                    </div>
                </div>
                {(this.props.link || this.props.hasButton || !this.props.hideCloseBtn) && (
                    <div className="custom-message-actions">
                        {this.props.link && (
                            <a href={this.getLink()}>
                                {t(`${this.props.link_name}`, {
                                    defaultValue: this.props.link_name,
                                })}
                            </a>
                        )}
                        {this.props.hasButton && (
                            <button
                                className="custom-message-button"
                                onClick={this.props.onButtonClick}
                            >
                                {t(`${this.props.buttonName}`, {
                                    defaultValue: this.props.buttonName,
                                })}
                            </button>
                        )}
                        {!this.props.hideCloseBtn && (
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                            >
                                <i className="icon-x-close"></i>
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(MessageCustom);
